import { Typography } from '@material-ui/core'
import StaticPopupModal from 'Components/SharedComponents/StaticPopupModal/StaticPopupModal'
import formatTools from 'web/src/Modules/Format/index'
import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { colors } from 'Themes/Colors'
import { useAppDispatch, useAppState } from 'Context/AppContext/AppContext'
import { DialogVariant, UPDATE_GLOBAL_DIALOG } from 'TypeDefs/AppContext'

export const TrialEndDialog = () => {
  const {
    ui: { dialog },
    nonprofitOrgConfig: { platformPlan },
  } = useAppState()

  const buttonClickHandler = () => {
    if (dialog.variant === DialogVariant.TRIAL_END)
      window.location.href = dialog?.url as string
  }
  const closeModalHandler = () => {
    dispatch({
      type: UPDATE_GLOBAL_DIALOG,
      payload: {
        isVisible: false,
        variant: null,
        url: '',
      },
    })
  }
  const dispatch = useAppDispatch()

  if (!dialog?.isVisible) {
    return null
  }
  return (
    <StaticPopupModal
      title={`End your 6-month ${formatTools.titleize(
        platformPlan || ''
      )} trial?`}
      buttonText='Continue with trial'
      buttonOnClickHandler={closeModalHandler}
      showSecondaryButton
      secondaryButtonText='Continue with plan change'
      withCloseIcon
      secondaryButtonHandler={buttonClickHandler}
      backdropClickHandler={closeModalHandler}
      withBackdrop
    >
      <Typography variant='body1'>
        Selecting a new plan will immediately end your 6-month platform trial of{' '}
        {formatTools.titleize(platformPlan || '')}. You can see the features of
        each of these plans in{' '}
        <StyledLink to='/settings/billing'>Manage Billing & Plan.</StyledLink>
      </Typography>
    </StaticPopupModal>
  )
}

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${colors.resiliaBlue};
  font-weight: 600;
`
